<app-modal class="ticket-details-modal" (dismiss)="doCleanup()">
    <ng-container modal-header>
        <h5 class="modal-title">
            {{ 'admin.tickets.details-modal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <div *ngIf="ticket">
            <div class="row">
                <div class="col s12">
                    <div *ngIf="ticket.ticketTools.length === 0; else toolTree"
                         [innerHTML]="'admin.tickets.details-modal.panel.noTickets' | translate"
                         style="font-weight: bold;"></div>
                    <ng-template #toolTree>
                        <app-tool-scan-tree
                            labelText="{{'admin.tickets.details-modal.panel.selectedTools'| translate}}"
                            [loading]="loading"
                            [parameters]="[{'value': 'registeredTime', 'label':'admin.tickets.details-modal.panel.parameters.registeredTime' },
                                           {'value': 'registeredCycles', 'label':'admin.tickets.details-modal.panel.parameters.registeredCycles'}]"
                            class="toolScanner"
                            [items]="ticket.ticketTools"
                        ></app-tool-scan-tree>
                    </ng-template>

                </div>
            </div>
            <div class="row">
                <div class="col s3">
                    <app-display-label
                        label="{{'admin.tickets.details-modal.panel.currentOperation' | translate}}"
                        [value]="ticket.currentOperation?.name"></app-display-label>
                </div>
                <div class="col s3">
                    <app-display-label
                        label="{{'admin.tickets.details-modal.panel.status' | translate}}"
                        [value]="ticket.status"></app-display-label>
                </div>
                <div class="col s3">
                    <app-display-label
                        label="{{'admin.tickets.details-modal.panel.createdDate' | translate}}"
                        [value]="ticket.createdDate"></app-display-label>
                </div>
                <div class="col s3">
                    <app-display-label
                        label="{{'admin.tickets.details-modal.panel.createdBy' | translate}}"
                        [value]="ticket.createdByName"></app-display-label>
                </div>
            </div>
            <div class="row">
                <div class="col s3">
                    <app-display-label
                        label="{{'admin.tickets.details-modal.panel.ticketStartDate' | translate}}"
                        [value]="ticket.startDate"></app-display-label>
                </div>
                <div class="col s3">
                    <app-display-label
                        label="{{'admin.tickets.details-modal.panel.ticketEndDate' | translate}}"
                        [value]="ticket.endDate"></app-display-label>
                </div>
                <div class="col s3 offser-3 priorityContainer">
                    <app-display-label
                        label="{{'admin.tickets.details-modal.panel.hasPriority' | translate}}"
                        [value]="ticket.hasPriority ? ('admin.tickets.table.hasPriority.true' | translate)
                             : ('admin.tickets.table.hasPriority.false' | translate)"></app-display-label>
                    <app-tooltip *ngIf="ticket.hasPriority" type="success"
                                 record="{{'admin.tickets.table.ticketPriority' | translate}}">
                    </app-tooltip>
                </div>
            </div>
            <div class="row" *ngIf="ticket.description">
                <div class="col s12">
                    <app-textbox label="{{'admin.tools.details.detailsPage.labels.description' | translate}}"
                                 class="text-box"
                                 [value]="ticket?.description"></app-textbox>
                </div>
            </div>
            <div class="row" *ngIf="ticket.infoFromLine">
                <div class="col s12">
                    <app-textbox label="{{'admin.tickets.details-modal.panel.lineInfo' | translate}}"
                                 class="text-box"
                                 [value]="ticket?.infoFromLine"></app-textbox>
                </div>
            </div>
            <div class="divider"></div>
            <div class="row" *ngIf="ticket.ticketOperations">
                <div class="col s12">
                    <app-accordion label="{{'admin.tickets.details-modal.panel.accordion.title' | translate}}">
                        <ng-container *ngFor="let ticketOperation of ticket.ticketOperations; let index = index;">
                            <app-accordion-item [open]="computeIsOpen(ticketOperation)">
                                <ng-template #head><i class="fa fa-circle"
                                                      [ngClass]="computeStatusClass(ticketOperation)"></i>
                                    {{ computeOperationHeader(ticketOperation) }}
                                </ng-template>
                                <ng-template #content>
                                    <div class="col s12">
                                        <div class="row">
                                            <div class="col s3">
                                                <app-display-label
                                                    label="{{'admin.tickets.details-modal.panel.accordion.startDate' | translate}}"
                                                    [value]="ticketOperation.startDate"></app-display-label>
                                            </div>
                                            <div class="col s3">
                                                <app-display-label
                                                    label="{{'admin.tickets.details-modal.panel.accordion.endDate' | translate}}"
                                                    [value]="ticketOperation.endDate"></app-display-label>
                                            </div>
                                            <div class="col s3">
                                                <app-display-label
                                                    label="{{'admin.tickets.details-modal.panel.accordion.status' | translate}}"
                                                    [value]="ticketOperation.status"></app-display-label>
                                            </div>
                                            <div class="col s3">
                                                <app-display-label
                                                    label="{{'admin.tickets.details-modal.panel.accordion.assignedTo' | translate}}"
                                                    [value]="ticketOperation.assignedTo?.fullName"></app-display-label>
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="computeIsAutomatic()">
                                            <div class="col s12">
                                                <app-display-label
                                                    label="{{'admin.tickets.details-modal.panel.accordion.description' | translate}}"
                                                    [value]="ticketOperation.description"></app-display-label>
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="computeIsAutomatic()">
                                            <div class="col s12">
                                                <label>{{
                                                        'admin.tickets.details-modal.panel.accordion.instructionFile' |
                                                            translate
                                                    }}:</label>
                                                <div *ngIf="ticketOperation.instructionFile">
                                                    <a (click)="download(ticketOperation.instructionFile)"
                                                       class="d-inline">
                                                        {{ ticketOperation.instructionFile?.name }}</a>
                                                    <app-button
                                                        *ngIf="ticketOperation.instructionFile?.name.endsWith('pdf')"
                                                        type="primary"
                                                        class="action-button"
                                                        (click)="viewFile(ticketOperation.instructionFile)">{{ 'generic.buttons.viewfile'| translate }}
                                                    </app-button>
                                                </div>
                                                <p *ngIf="!ticketOperation.instructionFile">N/A</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col s3">
                                                <app-display-label
                                                    label="{{'admin.tickets.details-modal.panel.accordion.comment' | translate}}"
                                                    [value]="ticketOperation.comment"></app-display-label>
                                            </div>
                                            <div class="col s3">
                                                <app-display-label
                                                    *ngIf="ticketOperation.nrOfTasks"
                                                    label="{{'admin.tickets.details-modal.panel.accordion.nrOfTasks' | translate}}"
                                                    [value]="ticketOperation.nrOfTasks"></app-display-label>
                                            </div>
                                            <div class="col s3" *ngIf="ticketOperation.ticketOperationTools.length">
                                                <p>{{ 'admin.tickets.details-modal.panel.accordion.tools' | translate }}</p>
                                                <app-tooltip type="info"
                                                             [displayType]="'tools'"
                                                             [record]="getOperationToolNames(ticketOperation)">
                                                </app-tooltip>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col s12">
                                                <label>{{ 'admin.tickets.details-modal.panel.accordion.document' | translate }}
                                                    :</label>
                                                <div *ngIf="ticketOperation.document">
                                                    <a id="value" class="d-inline"
                                                       (click)="download(ticketOperation.document)">
                                                        {{ ticketOperation.document?.name }}</a>
                                                    <app-button *ngIf="ticketOperation.document?.name.endsWith('pdf')"
                                                                type="primary"
                                                                class="action-button"
                                                                (click)="viewFile(ticketOperation.instructionFile)">{{ 'generic.buttons.viewfile'| translate }}
                                                    </app-button>
                                                </div>
                                                <p *ngIf="!ticketOperation.document">N/A</p>
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="ticketOperation.ticketOperationRecurrences.length">
                                            <div class="col s12">
                                                <p>{{ 'admin.tickets.details-modal.panel.accordion.recurrences' | translate }}</p>
                                                <div class="recurrence-container"
                                                     *ngFor="let recurrence of computeRecurrences(ticketOperation)">
                                                    <app-recurrence [recurrence]="recurrence"></app-recurrence>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="ticketOperation.ticketOperationTasks.length">
                                            <div class="col s12">
                                                <p>{{ 'admin.tickets.details-modal.panel.accordion.tasks' | translate }}</p>
                                                <div class="task-container"
                                                     *ngFor="let task of computeTasks(ticketOperation)">
                                                    <app-task [task]="task"></app-task>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </app-accordion-item>
                        </ng-container>
                    </app-accordion>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container modal-footer>
        <div *ngIf="ticket">
            <app-button *ngIf="computeCanRenderCloseButton(ticket)"
                        [disabled]="!ticket.canBeClosed"
                        type="danger"
                        (click)="emitCloseTicket()">
                {{ 'generic.buttons.cancel' | translate }}
            </app-button>
            <app-button type="simple"
                        (click)="close()">
                {{ 'generic.buttons.close' | translate }}
            </app-button>
        </div>
    </ng-container>
</app-modal>

<app-pdf-viewer></app-pdf-viewer>
